// extracted by mini-css-extract-plugin
export default {"__pagination__":"style___pagination____8tzfc","__page-item__":"style___page-item____595u0","paginate_container":"style_paginate_container__cJ9yP"};